/* SBM cart recovery 2026-09-18. No retries of an ambiguous cart mutation. */
(function () {
  'use strict';
  if (window.SBMCart) return;
  var active = null, mirrors = {}, records = {};
  var storageKey = 'sb_cart_attempts_v1';
  try { records = JSON.parse(sessionStorage.getItem(storageKey) || '{}') || {}; } catch (_) {}
  function persist() { try { sessionStorage.setItem(storageKey, JSON.stringify(records)); } catch (_) {} }
  function route(path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path; }
  function error(code, status, detail) { var e = new Error(code); e.code = code; e.status = status || 0; e.detail = detail || ''; return e; }
  function emit(name, data) {
    try { if (window.posthog) window.posthog.capture(name, Object.assign({ cart_recovery: '2026-09-18' }, data)); } catch (_) {}
    try { if (window.clarity) window.clarity('event', name); } catch (_) {}
    try { fetch('/apps/sb/track', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ e: name, v: data.visitor || '' }) }).catch(function () {}); } catch (_) {}
  }
  // Race the complete response (including body), rather than only response headers.
  function request(url, body, ms) {
    var controller = new AbortController(), timer;
    var operation = fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined, signal: controller.signal
    }).then(async function (r) {
      var data; try { data = await r.json(); } catch (_) { throw error('invalid-response', r.status); }
      if (!r.ok) throw error('http-error', r.status, String(data.description || data.message || data.error || '').slice(0, 300));
      return data;
    });
    var timeout = new Promise(function (_, reject) { timer = setTimeout(function () { reject(error('timeout')); controller.abort(); }, ms); });
    return Promise.race([operation, timeout]).finally(function () { clearTimeout(timer); });
  }
  function find(cart, record) {
    if (!cart || !Array.isArray(cart.items)) throw error('invalid-cart');
    return cart.items.find(function (line) { return line.properties && line.properties._sbCartAttempt === record.id; });
  }
  function result(line, record) {
    // Original price, before legitimate discounts, must always be positive.
    if (!(Number(line.original_price == null ? line.price : line.original_price) > 0)) throw error('invalid-price');
    if (Number(line.quantity) < record.quantity) throw error('partial-quantity');
    return { variantId: line.variant_id || line.id, items: [line], attemptId: record.id };
  }
  async function reconcile(record) { return find(await request(route('cart.js'), null, 8000), record); }
  async function run(options) {
    var realVid = Number(options.variantId), quantity = Number(options.quantity || 1);
    if (!Number.isSafeInteger(realVid) || realVid <= 0 || !Number.isInteger(quantity) || quantity < 1) throw error('invalid-selection');
    var props = Object.assign({}, options.properties), designId = props._designId || '';
    if (!designId) throw error('missing-design');
    var key = JSON.stringify([realVid, quantity, props]);
    var context = { design_id: designId, source_variant: String(realVid), visitor: props._visitor || '' };
    emit('sb_atc_attempt', context);
    var previous = records[key];
    if (previous) {
      var existing;
      try { existing = await reconcile(previous); } catch (_) { throw error('cart-unconfirmed'); }
      if (existing) { emit('sb_atc_recovered', context); return result(existing, previous); }
      // An absent line is not proof that an in-flight POST was never committed.
      if (previous.phase === 'pending' || previous.phase === 'unknown') throw error('cart-unconfirmed');
      delete records[key]; persist();
    }
    var record = { id: 'sb_' + (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2)), quantity: quantity, phase: 'ready' };
    props._sbCartAttempt = record.id;
    var cartVid = realVid;
    var mirrorKey = realVid + '|' + designId;
    if (!options.catalogOnly) {
      try {
        var saved = mirrors[mirrorKey];
        if (!saved || Date.now() - saved.time > 900000) {
          var mirror = await request('/apps/sb/checkoutproduct', Object.assign({}, options.mirrorBody || {}, { vid: String(realVid), designId: designId }), 6000);
          if (!Number.isSafeInteger(Number(mirror.variantId)) || Number(mirror.variantId) <= 0) throw error('invalid-mirror');
          saved = mirrors[mirrorKey] = { time: Date.now(), value: mirror };
        }
        cartVid = Number(saved.value.variantId);
        if (saved.value.previewUrl) props._previewUrl = saved.value.previewUrl;
        emit('sb_atc_mirror_ready', Object.assign({}, context, { variant_id: String(cartVid) }));
      } catch (e) {
        emit('sb_atc_catalog_fallback', Object.assign({}, context, { stage: 'mirror', status: e.status, reason: e.code || e.message }));
      }
    }
    async function add(id, fallbackAllowed) {
      record.phase = 'pending'; records[key] = record; persist();
      var data;
      try { data = await request(route('cart/add.js'), { items: [{ id: id, quantity: quantity, properties: props }] }, 15000); }
      catch (e) {
        var definitive = e.code === 'http-error' && [400, 404, 422].indexOf(e.status) >= 0;
        record.phase = definitive ? 'rejected' : 'unknown'; persist();
        emit('sb_atc_cart_error', Object.assign({}, context, { variant_id: String(id), status: e.status, reason: e.code || e.message, detail: e.detail }));
        var line;
        try { line = await reconcile(record); } catch (_) { throw error('cart-unconfirmed'); }
        if (line) { record.phase = 'added'; persist(); return result(line, record); }
        if (!definitive) throw error('cart-unconfirmed');
        if (fallbackAllowed && id !== realVid) {
          emit('sb_atc_catalog_fallback', Object.assign({}, context, { stage: 'cart', status: e.status }));
          return add(realVid, false);
        }
        delete records[key]; persist(); throw e;
      }
      var line = data && Array.isArray(data.items) && data.items.find(function (item) { return item.properties && item.properties._sbCartAttempt === record.id; });
      if (!line) {
        try { line = await reconcile(record); } catch (_) {}
        if (!line) { record.phase = 'unknown'; persist(); throw error('cart-unconfirmed'); }
      }
      record.phase = 'added'; persist();
      return result(line, record);
    }
    var added = await add(cartVid, true);
    emit('sb_atc_cart_confirmed', Object.assign({}, context, { variant_id: String(added.variantId) }));
    return added;
  }
  window.SBMCart = {
    version: '2026-09-18',
    busy: function () { return !!active; },
    add: function (options) {
      if (active) return Promise.reject(error('in-flight'));
      active = run(options).finally(function () { active = null; });
      return active;
    },
    route: route,
    showError: function (host, e) {
      var box = host.querySelector('[data-sb-cart-error]');
      if (!box) { box = document.createElement('div'); box.setAttribute('data-sb-cart-error', ''); host.appendChild(box); }
      box.hidden = false; box.setAttribute('role', 'alert'); box.setAttribute('tabindex', '-1');
      box.style.cssText = 'background:#fff8f1;color:#26211a;border:1px solid #b49a63;border-radius:12px;padding:12px;font-size:14px;line-height:1.45;margin-top:8px';
      box.textContent = e && ['cart-unconfirmed', 'invalid-price', 'partial-quantity'].indexOf(e.code) >= 0
        ? 'Your design is saved. Please check your cart before trying again.'
        : 'Your design is saved. We couldn’t complete the add. Please try again, or check your cart.';
      var link = document.createElement('a'); link.href = route('cart'); link.textContent = ' View my cart'; link.style.cssText = 'color:inherit;text-decoration:underline;font-weight:700'; box.appendChild(link);
      box.focus({ preventScroll: true });
    },
    clearError: function (host) { var box = host.querySelector('[data-sb-cart-error]'); if (box) box.hidden = true; }
  };
})();
